import React, { Component } from "react";

import martina from "../../assets/images/martina.jpg";
import mathias from "../../assets/images/mathias.jpg";
import tara from "../../assets/images/tara.jpg";
import thora from "../../assets/images/thora.jpg";

import classes from "./Content.module.css";

import IntroBox from "../../components/IntroBox/IntroBox";
import LinkBox from "../../components/LinkBox/LinkBox";
import Profiles from "../../components/Profiles/Profiles";

class Content extends Component {
  state = {
    members: [
      {
        name: "Martina Førre",
        picture: martina
      },
      {
        name: "Mathias Ahrn",
        picture: mathias
      },
      {
        name: "Tara Jørgensen",
        picture: tara
      },
      {
        name: "Thora Mothes",
        picture: thora
      }
    ]
  };

  render() {
    return (
      <div>
        <IntroBox />
        <div className={classes.air}>
          <LinkBox />
        </div>
        <div className={classes.air}>
          <Profiles profiles={this.state.members} />
        </div>
      </div>
    );
  }
}

export default Content;
